import script from "./Stream.vue?vue&type=script&setup=true&lang=js"
export * from "./Stream.vue?vue&type=script&setup=true&lang=js"

import "./Stream.vue?vue&type=style&index=0&id=a80f0dc8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a80f0dc8"]])

export default __exports__